import { isB2C } from '@app/helpers'

import { GetParticipantJobTitleParams } from './types'

export const getParticipantJobTitle = ({
  participant,
  transactionType,
  currentUserId,
  t,
}: GetParticipantJobTitleParams): string => {
  if (!participant) return ''

  if (participant.userId === currentUserId) {
    return t('Chat.Message.You')
  }

  if (participant.isPrivateAdvertiser) {
    return t('Chat.Sidebar.Participants.PrivateAdvertiser')
  }

  if (isB2C(participant)) {
    if (transactionType?.id === 'Rent') return t('Chat.Participants.Renter')
    if (transactionType?.id === 'Sell')
      return t('Chat.Sidebar.Participants.Buyer')
    return ''
  }

  if (participant.jobTitle) {
    if (participant.agencyName)
      return t('Chat.Participants.JobTitleWithAccount', {
        jobTitle: participant.jobTitle,
        agency: participant.agencyName,
      })
    return participant.jobTitle
  }

  if (participant.isAgent) {
    if (participant.agencyName)
      return t('Chat.Participants.DefaultJobTitleWithAccount', {
        agency: participant.agencyName,
      })
    return t('Chat.Participants.DefaultJobTitle')
  }

  return participant.agencyName || ''
}